import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import styled from '@emotion/styled';
import { PropertyForm, PropertyMatch, Result, SelectedCity } from '../types';
import { Loader } from 'semantic-ui-react';
import AddressResults from './AddressResults';

const Input = styled.input`
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  height: 40px;
  :focus {
    outline: none;
  }
`;

interface Props {
  findMatches: any;
  typeAheadMatches: any;
  callRpadValidation: any;
  property: PropertyForm;
  setProperty: React.Dispatch<React.SetStateAction<PropertyForm>>;
  setTypeAheadMatches: React.Dispatch<React.SetStateAction<PropertyMatch[]>>;
  isLoading: boolean;
  changePropertyInfo: any;
  setAddressResultClicked: React.Dispatch<React.SetStateAction<boolean>>;
}
export default function AddressFieldTypeAhead(props: Props) {
  const [resultCount, setResultCount] = useState(15);
  const [searchTerm, setSearchTerm] = useState('');
  useEffect(() => {
    window.addEventListener('click', () => {
      props.setTypeAheadMatches([])
    });
    return () => {
      window.removeEventListener('click', () => {
        props.setTypeAheadMatches([])
      });
    };
  }, []);
  return (
    <div style={{position:'relative'}}>
      <div style={{ flexDirection: 'column', display: 'flex', position: 'relative' }}>
        <label>Address</label>
        <Input
          style={{ width: 555, marginRight: 8, marginTop: 8 }}
          onChange={e => {
            props.changePropertyInfo('address', e.target.value);
            props.findMatches(e, props.property, 15, props.setTypeAheadMatches);
            setSearchTerm(e.target.value);
          }}
          value={props.property.address || ''}
        />
        <span style={{ position: 'absolute', top: 52, right: 32 }}>
          <Loader active={props.isLoading} size="tiny" />
        </span>
      </div>
      {props.typeAheadMatches?.results?.length > 0 && (
        <div
          style={{
            position: 'absolute',
            zIndex: 10000,
            top: 76,
            width: 950,
            boxShadow: '0px 0px 16px 0px #eae8e5',
            maxHeight: 350,
            overflow: 'auto',
          }}
          id="infiniteDiv"
        >
          <InfiniteScroll
            dataLength={props.typeAheadMatches.results.length} //This is important field to render the next data
            next={() => {
              const newResultCount = resultCount + 15;
              props.callRpadValidation(searchTerm, props.property, newResultCount, props.setTypeAheadMatches);
              setResultCount(newResultCount);
            }}
            hasMore={props.typeAheadMatches.results.length !== props.typeAheadMatches.totalCount}
            loader={<div style={{ padding: 16, backgroundColor: '#fff' }}>Loading...</div>}
            scrollThreshold={0.2}
            scrollableTarget="infiniteDiv"
          >
            <AddressResults
              matches={props.typeAheadMatches.results}
              searchText={searchTerm}
              handleClick={(r: Result, s: SelectedCity) => {
                const property: PropertyForm = {
                    id: r.id,
                    rpadId:r.rpadId,
                    address: r.address,
                    unit: r.aptNo,
                    section: r.property.section,
                    block: r.property.block,
                    lot: r.property.lot,
                    owners: r.owners,
                    qualifier: r.property.qualifier,
                    selectedCity: s.municipalityId
                    ? s
                    : {
                        county: r.muniTypes[0]?.name,
                        countyId: r.muniTypes[0]?.id,
                        municipality: r.muniTypes[1]?.name,
                        municipalityId: r.muniTypes[1]?.id,
                        municipalityType: r.muniTypes[1]?.type,
                        subMunicipality: r.muniTypes[2]?.name,
                        subMunicipalityType: r.muniTypes[2]?.type,
                        subMunicipalityId: r.muniTypes[2]?.id,
                        swisCode: r.muniTypes[2]?.swisCode || r.muniTypes[1]?.swisCode,
                        stateCode: r.muniTypes[0]?.stateCode,
                        stateName: r.muniTypes[0]?.state,
                      },
                };
                props.setProperty(property);
                props.setAddressResultClicked(true)
                props.setTypeAheadMatches([])
              }}
              property={props.property}
              
            />
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
}
